import { render, staticRenderFns } from "./notifications-setting.vue?vue&type=template&id=518cb79d"
import script from "./notifications-setting.vue?vue&type=script&lang=js"
export * from "./notifications-setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports